/**
 * @description Channel Partner session API (LYN-309) — own-row only
 *
 * @dependencies apiClient
 * @notes Not /api/admin. Name and branding are separate writers.
 */

import apiClient from './apiClient';

export const getChannelPartnerMe = () =>
  apiClient.get('/channel-partner').then((r) => r.data);

export const updateChannelPartnerName = (name) =>
  apiClient.put('/channel-partner/name', { name }).then((r) => r.data);

export const updateChannelPartnerBranding = (branding) =>
  apiClient.put('/channel-partner/branding', { branding }).then((r) => r.data);

export const uploadChannelPartnerLogo = (file) => {
  const formData = new FormData();
  formData.append('logo', file);
  return apiClient.post('/channel-partner/branding/logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};

export const uploadChannelPartnerLogoMark = (file) => {
  const formData = new FormData();
  formData.append('logoMark', file);
  return apiClient.post('/channel-partner/branding/logo-mark', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};

export const uploadChannelPartnerFavicon = (file) => {
  const formData = new FormData();
  formData.append('favicon', file);
  return apiClient.post('/channel-partner/branding/favicon', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};

export const deleteChannelPartnerLogo = () =>
  apiClient.delete('/channel-partner/branding/logo').then((r) => r.data);

export const deleteChannelPartnerLogoMark = () =>
  apiClient.delete('/channel-partner/branding/logo-mark').then((r) => r.data);

export const deleteChannelPartnerFavicon = () =>
  apiClient.delete('/channel-partner/branding/favicon').then((r) => r.data);

export const getChannelPartnerCustomDomainStatus = () =>
  apiClient.get('/channel-partner/custom-domain/status').then((r) => r.data);

export const registerChannelPartnerCustomDomain = (domainBase) =>
  apiClient.post('/channel-partner/custom-domain/register', { domainBase }).then((r) => r.data);

export const verifyChannelPartnerCustomDomain = () =>
  apiClient.post('/channel-partner/custom-domain/verify').then((r) => r.data);

export const recheckChannelPartnerCustomDomain = () =>
  apiClient.post('/channel-partner/custom-domain/recheck').then((r) => r.data);

export const disconnectChannelPartnerCustomDomain = () =>
  apiClient.delete('/channel-partner/custom-domain').then((r) => r.data);

export const getChannelPartnerEmailSendingDomain = () =>
  apiClient.get('/channel-partner/email-sending-domain').then((r) => r.data);

export const connectChannelPartnerEmailSendingDomain = (domain) =>
  apiClient.post('/channel-partner/email-sending-domain/connect', { domain }).then((r) => r.data);

export const verifyChannelPartnerEmailSendingDomain = () =>
  apiClient.post('/channel-partner/email-sending-domain/verify').then((r) => r.data);

export const disconnectChannelPartnerEmailSendingDomain = () =>
  apiClient.post('/channel-partner/email-sending-domain/disconnect').then((r) => r.data);
